import ROUTES from "~/kernel/routing/ROUTES";
import Container from "./Container";
import Link from "./Link";
import useTranslation from "~/kernel/internationalization/useTranslation";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bottom-0 border-t border-t-slate-200 bg-white">
      <Container>
        <div className="flex flex-row flex-wrap justify-between">
          <div className="py-8 px-5 space-y-3">
            <div>
              <p className="font-bold">{t("footer.contact")}</p>
              <p>
                <Link to={ROUTES.help.path()}>{t("footer.contactForm")}</Link>
              </p>
            </div>
            <div>
              <p className="font-bold">{t("footer.forSalons")}</p>
              <p>
                <Link to={ROUTES.connectCompany.path({})}>
                  {t("footer.connectCompany")}
                </Link>
              </p>
            </div>
          </div>
          <div className="py-8 px-5">
            <p className="font-bold">{t("footer.help")}</p>
            <p>
              <Link to={ROUTES.help.path()}>{t("footer.commonQuestions")}</Link>
            </p>
            <p>
              <Link to={ROUTES.help.path()}>{t("footer.giveFeedback")}</Link>
            </p>
            <p>
              <Link to={ROUTES.termsOfUsage.path()}>
                {t("footer.termsOfUsage")}
              </Link>
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
}
